const hideAlert = () => {
    const el = document.querySelector('.alert');
    if(el) el.parentElement.removeChild(el)
}

export const showAlert = (status, msg, time=5000) => {
    hideAlert();
    const markUp = `<div class="alert alert--${status}">${msg}</div>`;

    document.querySelector('body').insertAdjacentHTML('afterbegin', markUp);
    setTimeout(hideAlert, time)
}